<template>
	<div class="addMemberDraw">
		<el-drawer title="新增成员" :visible.sync="drawer" :wrapperClosable="false" direction="rtl" :before-close="handleClose" size="724px">
			<div>
				<div class="ml-46 mt-32">
					<el-checkbox @change="checkAllClick" v-model="allChecked" style="color: #3d3d3d" class="mr-16">全选</el-checkbox>
					<span class="font-h5-regular" style="color: #3d3d3d">已选{{ checkedLength }}个</span>
				</div>
				<div style="margin-left: 34px" class="mt-16 mr-24">
					<multi-table
						:stickyHeader="false"
						ref="multiTable"
						:total="total"
						:columns="columns"
						:options="options"
						:list="tableData"
						:selectionChange="selectionChange"
						:selectable="selectable"
						@gePartnerList="gePartnerList"
					></multi-table>
				</div>
			</div>
			<div class="demo-drawer__footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="save" v-loading="loading" :disabled="checkedLength === 0" class="save">
					<div class="flex-center">
						<span>保存</span>
						<i class="el-icon-loading" v-if="isShowIcon"></i>
					</div>
				</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import { getUsersList, addAndDeletMembers } from '@/api/teamManage';
import { columns } from './columns.js';
import throttle from 'lodash/throttle';
export default {
	name: 'addMemberDraw',
	data() {
		return {
			columns,
			drawer: false,
			tableData: [],
			loading: false,
			tableHead: {
				background: '#ebedf5',
				color: '#4e596a',
			},
			pageInfo: {
				pageNo: 1,
				pageSize: 10,
				notRoleId: 0,
			},
			total: 0,
			options: { selectable: true },
			checkedLength: 0,
			checkedList: [],
			filterArr: [],
			isShowIcon: false,
			allChecked: false,
		};
	},
	computed: {},
	methods: {
		//给选中的添加flag属性
		selectable(row) {
			return row.flag == 0;
		},
		show(id) {
			this.drawer = true;
			this.pageInfo.notRoleId = id;
			this.getUsersList(id);
		},
		handleClose() {
			this.drawer = false;
			this.$refs.multiTable.$refs.baseTable.$refs.table.clearSelection();
		},
		async getUsersList() {
			const { pageInfo } = this;
			const { list, total } = await getUsersList(pageInfo);
			this.tableData = list;
			this.total = total;
		},
		//分页
		gePartnerList(val) {
			this.pageInfo.pageNo = val.page_index;
			this.pageInfo.pageSize = val.page_size;
			this.getUsersList();
		},
		// 列表改变的时候控制全选框
		selectionChange(val) {
			this.checkedList = val;
			this.checkedLength = val.length;
			this.allChecked = this.checkedLength && this.checkedLength === this.filterArr.length;
		},
		//保存按钮
		save: throttle(async function () {
			try {
				this.isShowIcon = true;
				const idArr = this.checkedList?.map(item => item.id);
				const params = {
					userId: idArr,
					roleId: this.pageInfo.notRoleId,
				};
				await addAndDeletMembers(params);
				this.$emit('refresh');
				this.$message.success('保存成功');
			} finally {
				this.drawer = false;
				this.isShowIcon = false;
			}
		}, 1000),
		//全选框控制列表
		checkAllClick(checked) {
			this.filterArr = [];
			this.filterArr = this.tableData.filter(item => item.flag == 0);
			this.$refs.multiTable.toggleSelection(this.filterArr, checked);
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-drawer__body {
	margin-bottom: 64px;
}

.demo-drawer__footer {
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	position: absolute;
	bottom: 0px;
	width: 100%;
	height: 64px;
	z-index: 9999;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	&/deep/.el-button + .el-button {
		margin-right: 15px !important;
		margin-left: 16px !important;
		width: 88px;
	}

	&/deep/:first-child {
		width: 76px !important;
	}

	&/deep/ .save :first-child {
		width: auto !important;
	}
}

.ml-46 {
	margin-left: 46px !important;
}
</style>
